<template>
  <v-container fluid class="text-center">
    <Loader :loading="loading" />
    <Table-Container title="Dispositivos" :exportInfo="exportItems">
      <template v-slot:buttons>
        <Basic-Btn text="Agregar" color="primary" icon="mdi-plus" @click="dialogs.new = true" :loading="loading" />
        <Basic-Btn text="Actualizar" color="success" icon="mdi-refresh" @click="refresh()" :loading="loading" />
      </template>
      <template v-slot:search>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" class="mx-2" single-line hide-details maxlength="150"></v-text-field>
      </template>
      <v-data-table v-model="selected" :headers="headers" :items="items" :loading="loading" :search="search" :footer-props="{ 'items-per-page-text': 'Elementos por página', 'items-per-page-options': [20, 50, -1] }" :items-per-page="10" item-key="id" class="elevation-1" dense>
        <v-progress-linear slot="progress" color="secondary" indeterminate></v-progress-linear>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip left
            ><template v-slot:activator="{ on, attrs }"><v-icon class="mr-2" size="22" color="primary" dark v-bind="attrs" v-on="on" :disabled="loading" @click="view(item)">mdi-pencil</v-icon></template
            ><span>Editar</span></v-tooltip
          >
          <v-tooltip right
            ><template v-slot:activator="{ on, attrs }"><v-icon class="mr-2" size="22" color="error" dark v-bind="attrs" v-on="on" :disabled="loading" @click="remove(item.iddispositivo)">mdi-delete</v-icon></template
            ><span>Eliminar</span></v-tooltip
          >
        </template>
        <template v-slot:[`item.fecha_creacion`]="{ item }">
          {{ dateFormat(item.fecha_creacion) }}
        </template>
        <template v-slot:[`item.fecha_actualizacion`]="{ item }">
          {{ dateFormat(item.fecha_creacion) }}
        </template>
        <template v-slot:[`footer.page-text`]="props"> Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }} </template>
        <template v-slot:no-data> No hay información disponible </template>
        <template v-slot:no-results> No se obtuvieron resultados </template>
      </v-data-table>
    </Table-Container>

    <Dialog-Form :estate="dialogs.new" title="Nuevo dispositivo">
      <template v-slot:buttons>
        <Basic-Btn text="Cancelar" color="error" icon="mdi-close" @click="cancel()" :loading="loading" />
        <Basic-Btn text="Guardar" color="success" icon="mdi-check" @click="save()" :loading="loading" />
      </template>
      <v-form ref="formNew" lazy-validation>
        <v-row>
          <v-col cols="12">
            <v-text-field v-model="forms.new.nombre" label="Nombre" prepend-icon="mdi-account-group" :rules="rules.nombre" :disabled="loading" dense outlined required></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field v-model="forms.new.ip" label="IP" prepend-icon="mdi-search-web" :disabled="loading" dense outlined required></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field v-model.number="forms.new.puerto" label="Puerto" prepend-icon="mdi-serial-port" type="number" :disabled="loading" dense outlined required></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </Dialog-Form>
    <Dialog-Form :estate="dialogs.update" title="Actualizar puesto">
      <template v-slot:buttons>
        <Basic-Btn text="Cancelar" color="error" icon="mdi-close" @click="cancel()" :loading="loading" />
        <Basic-Btn text="Actualizar" color="success" icon="mdi-check" @click="update()" :loading="loading" />
      </template>
      <v-form ref="formUpdate" lazy-validation>
        <v-row>
          <v-col cols="12">
            <v-text-field v-model="forms.update.nombre" label="Nombre" prepend-icon="mdi-account-group" :rules="rules.nombre" :disabled="loading" dense outlined required></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field v-model="forms.update.ip" label="IP" prepend-icon="mdi-search-web" :disabled="loading" dense outlined required></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field v-model.number="forms.update.puerto" label="Puerto" prepend-icon="mdi-serial-port" type="number" :disabled="loading" dense outlined required></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field v-model="forms.update.fecha_creacion" label="Fecha de creación" :disabled="true" prepend-icon="mdi-calendar-today" dense outlined required></v-text-field>
          </v-col>
           <v-col cols="6">
            <v-text-field v-model="forms.update.fecha_actualizacion" label="Fecha de Actualización" :disabled="true" prepend-icon="mdi-calendar" dense outlined required></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </Dialog-Form>

    <Delete-Message :estate="dialogs.remove" msg="¿Realmente desea eliminar el dispositivo?">
      <template v-slot:buttons>
        <Basic-Btn text="Cancelar" color="disabled" icon="mdi-close" @click="cancel()" :loading="loading" />
        <Basic-Btn text="Eliminar" color="error" icon="mdi-check" @click="remove()" :loading="loading" />
      </template>
    </Delete-Message>
    <BasicAlert :active.sync="alert.active" :msg="alert.msg" :color="alert.color" />
  </v-container>
</template>

<script>
import services from "@/utils/services";
import { Loader, DialogForm, BasicAlert, TableContainer, BasicBtn, DeleteMessage } from "@/components";
import moment from "moment";
import {isIPv4} from 'is-ip';


export default {
  name: "device",
  components: {
    Loader,
    DialogForm,
    BasicAlert,
    TableContainer,
    BasicBtn,
    DeleteMessage,
  },
  data: () => ({
    loading: false,
    alert: {
      active: false,
      color: "error",
      msg: "",
    },
    search: "",
    headers: [
      { text: "ID", align: "left", sortable: true, value: "iddispositivo" },
      { text: "Nombre", align: "left", sortable: true, value: "nombre" },
      { text: "IP", align: "left", sortable: true, value: "ip" },
      { text: "Puerto", align: "left", sortable: true, value: "puerto" },
      { text: "Fecha creación", align: "left", sortable: true, value: "fecha_creacion" },
      { text: "Fecha actualización", align: "left", sortable: true, value: "fecha_actualizacion" },
      { text: "Acciones", align: "left", sortable: false, value: "actions" },
    ],
    items: [],
    users: [],
    selected: [],
    deleted: null,
    forms: {
      new: {
        nombre: "",
        ip: "",
        puerto: "",
      },
      update: {
        idpuesto: "",
        nombre: "",
        ip: "",
        puerto: "",
      },
    },
    rules: {
      nombre: [(v) => !!v || "El campo es requerido", (v) => (v && v.length <= 100) || "El campo excede la longitud máxima"],
    },
    dialogs: {
      new: false,
      update: false,
      remove: false,
    },
  }),
    computed: {
    exportItems() {
      let array = [];
      for (let data of this.items) {
        array.push({
          id: data.iddispositivo ? data.iddispositivo : "",
          nombre: data.nombre ? data.nombre : "",
          ip: data.ip ? data.ip : "",
          puerto: data.puerto ? data.puerto : "",
          fecha_actualizacion: data.fecha_creacion ? this.dateFormat(data.fecha_actualizacion) : "",
          fecha_creacion: data.fecha_creacion ? this.dateFormat(data.fecha_creacion) : "",
        });
      }
      return array;
    },
  },
  mounted() {
    this.refresh();
  },
  methods: {
    async refresh() {
      this.loading = true;
      this.axios
        .get(services.routes.catalog + '/device')
        .then((response) => {
            this.items = response.data.data
        })
        .catch((error) => {
            this.alert.active = true;
            this.alert.color = "error";
            this.alert.msg = error.response.data.message || "Servicio no disponible";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cancel() {
      if (this.dialogs.new) {
        this.$refs.formNew.reset();
        for (let key in this.forms.new) {
          this.forms.new[key] = "";
        }
        this.dialogs.new = false;
      } else if (this.dialogs.update) {
        this.dialogs.update = false;
      } else if (this.dialogs.remove) {
        this.dialogs.remove = false;
      }
    },
    save() {
      if (this.$refs.formNew.validate()) {
        this.loading = true;
        let data = JSON.parse(JSON.stringify(this.forms.new));
        if(isIPv4(data.ip)){
        this.axios
          .post(services.routes.catalog + '/device', { data })
          .then((response) => {
            this.cancel();
            this.refresh();
            this.alert.active = true;
            this.alert.color = "success";
            this.alert.msg = "Dispositivo agregado exitosamente";
          })
          .catch((error) => {
            this.alert.active = true;
            this.alert.color = "error";
            this.alert.msg = error.response.data.message || "Servicio no disponible";
          })
          .finally(() => {
            this.loading = false;
          });
          }else{
        this.loading = false;
        this.alert.active = true;
        this.alert.color = "error";
        this.alert.msg = "Formato de IP incorrecto";
          }
      } else {
        this.alert.active = true;
        this.alert.color = "error";
        this.alert.msg = "La información es incorrecta";
      }
    },
    view(data) {
      this.forms.update = JSON.parse(JSON.stringify(data));
      this.forms.update.fecha_creacion = this.dateFormat(data.fecha_creacion)
      this.forms.update.fecha_actualizacion = this.dateFormat(data.fecha_actualizacion)
      this.dialogs.update = true;
    },
    update() {
      if (this.$refs.formUpdate.validate()) {
        this.loading = true;
        let data = JSON.parse(JSON.stringify(this.forms.update));
        if(isIPv4(data.ip)){
        this.axios
          .put(services.routes.catalog + '/device', { data })
          .then((response) => {
            this.cancel();
            this.refresh();
            this.alert.active = true;
            this.alert.color = "success";
            this.alert.msg = "Dispositivo actualizado exitosamente";
          })
          .catch((error) => {
            this.alert.active = true;
            this.alert.color = "error";
            this.alert.msg = error.response.data.message || "Servicio no disponible";
          })
          .finally(() => {
            this.loading = false;
          });
          }else{
        this.loading = false;
        this.alert.active = true;
        this.alert.color = "error";
        this.alert.msg = "Formato de IP incorrecto";
          }
      } else {
        this.alert.active = true;
        this.alert.color = "error";
        this.alert.msg = "La información es incorrecta";
      }
    },
    remove(id) {
      if (!id) {
        this.loading = true;
        this.axios
          .delete(services.routes.catalog + '/device', { data: { data: { iddispositivo: this.deleted } } })
          .then((response) => {
            this.cancel();
            this.refresh();
            this.alert.active = true;
            this.alert.color = "success";
            this.alert.msg = "Dispositivo eliminado exitosamente";
          })
          .catch((error) => {
            this.alert.active = true;
            this.alert.color = "error";
            this.alert.msg = error.response.data.message || "Servicio no disponible";
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.deleted = id;
        this.dialogs.remove = true;
      }
    },
    dateFormat(date) {
      return moment(date).format("DD/MM/YYYY h:mm:ss A");
    },
  },
};
</script>

<style scoped></style>
